import React from "react";

import Input from "../../components/form/Input";
import Select from "../../components/form/Select";
import Autocomplete from "../../components/form/fields5/Autocomplete";
import BooleanSelectField from "../../components/form/fields5/BooleanSelectField";
import ScannerInput from "../../components/form/ScannerInput";
import ScannerSelect from "../../components/form/ScannerSelect";
import ScannerAutocomplete from "../../components/form/ScannerAutocomplete";
import SerialNumberField from "../../components/form/SerialNumberField";

export default function ConfigurableField({ field, disabledForm }) {
  const isAvailableOptionsEnabled = field.availableOptions && field.availableOptions.length > 0;

  if (field.multipleValues && field.fieldType === "string") {
    return (
      <SerialNumberField
        name={`customFields.field_${field.id}`}
        label={field.defaultLabel}
        multiScanLabel={field.defaultLabel}
        disabled={disabledForm}
      />
    );
  }

  if (isAvailableOptionsEnabled) {
    if (field.restrictToAvailableOptions) {
      return field.enableBarcodeScanner ? (
        <ScannerSelect
          size="small"
          name={`customFields.field_${field.id}`}
          label={field.defaultLabel}
          options={field.availableOptions.map(value => [value, value])}
          disabled={disabledForm}
        />
      ) : (
        <Select
          size="small"
          name={`customFields.field_${field.id}`}
          label={field.defaultLabel}
          options={field.availableOptions.map(value => [value, value])}
          openOnFocus
          showNAButton={false}
          disabled={disabledForm}
        />
      );
    } else {
      return field.enableBarcodeScanner ? (
        <ScannerAutocomplete
          saveCustomOption
          forcePopupIcon
          name={`customFields.field_${field.id}`}
          label={field.defaultLabel}
          options={field.availableOptions.map(value => ({
            value,
            label: value,
          }))}
          disabled={disabledForm}
        />
      ) : (
        <Autocomplete
          freeSolo
          openOnFocus
          forcePopupIcon
          name={`customFields.field_${field.id}`}
          label={field.defaultLabel}
          options={field.availableOptions.map(value => ({
            value,
            label: value,
          }))}
          disabled={disabledForm}
        />
      );
    }
  }

  if (field.fieldType === "string") {
    return field.enableBarcodeScanner ? (
      <ScannerInput
        type="autoExpand"
        name={`customFields.field_${field.id}`}
        label={field.defaultLabel}
        disabled={disabledForm}
      />
    ) : (
      <Input
        type="autoExpand"
        name={`customFields.field_${field.id}`}
        label={field.defaultLabel}
        disabled={disabledForm}
      />
    );
  }

  return field.fieldType === "decimal" ? (
    <Input
      type="number"
      step="any"
      showNAButton={false}
      treatZeroAsBlank={false}
      name={`customFields.field_${field.id}`}
      label={field.defaultLabel}
      disabled={disabledForm}
    />
  ) : field.fieldType === "boolean" ? (
    <BooleanSelectField
      name={`customFields.field_${field.id}`}
      label={field.defaultLabel}
      disabled={disabledForm}
      allowEmptyOption={false}
      options={[
        { value: "true", label: "Yes" },
        { value: "false", label: "No" },
      ]}
    />
  ) : null;
}
